import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { SpendingCardRegion } from '../../entities/enums/SpendingCardRegionEnum'

export const useSpendingCardRegion = () => {
  const {
    enable_airwallex_ca: useAirwallexCA,
    enable_airwallex_uk: useAirwallexUK,
  } = useSelector(makeSelectFeatureSwitches())

  if (useAirwallexCA) return { region: SpendingCardRegion.CA }
  if (useAirwallexUK) return { region: SpendingCardRegion.UK }
  return { region: SpendingCardRegion.US }
}
